content-grid-formatter {
  width: 100%;
  align-items: var(--align-items, flex-start);
  justify-content: var(--justify-content);
  grid-template-columns: repeat(var(--columns), 1fr);
  column-gap: var(--column-gap, 0);
  row-gap: var(--row-gap, 0);
  * {
    box-sizing: border-box;
  }
  &[type="grid"] {
    display: grid;
  }

  &[type="flex"] {
    display: flex;
    flex-wrap: wrap;  
    > * {
      overflow: auto;
      flex: 0 0 auto;
      width: calc(100%/var(--columns));
    }
  }
  > [flex-shrink="true"] {
    width: auto;
    flex-shrink: 1;
  }
  &[flex-shrink="true"] > * {
    flex-shrink: 1;
  }
  &[flex-grow="true"] > * {
    flex-grow: 1;
  }
  > [flex-grow="true"] {
    width: auto;
    flex-grow: 1;
  }
}